import illutrationMaterial from "./../../assets/images/Illustration_Material.png"
import alertStatus from "./../../assets/images/alert_status.svg"
import illustration_p1 from "./../../assets/images/Illustration_P1.png"
import { orLossFilters, orLossKPICardsData } from '../api/orltAPI';
import { OrLossTreeContainer } from 'Samarth Module/pages/orLossTree/orLossTreeContainer';


// KPI configurations
export const KPI_CONFIG = {
  'Or Loss Tree': [
    {
      label: "OR%",
      img: illutrationMaterial,
      values: {
        value: "OR_Percentage",
        changeKey: "OR_Percentage_Change"
      }
    },
    {
      label: "Production Plan",
      img: illustration_p1,
      values: {
        value: "ProductionPlan",
        changeKey: "ProductionPlan_Change"
      }
    },
    {
      label: "OR Loss",
      img: alertStatus,
      values: {
        value: "OR_Loss",
        changeKey: "OR_Loss_Change"
      }
    }
  ]
};

// UI configurations
export const UI_CONFIG = {
  'Or Loss Tree': {
    showKPI: true,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: false,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showToogleButton: true,
    toggleBtn: ['Corrected Plan', 'Original Plan']
  }
};

// API configurations
export const API_CONFIG = {
  'Or Loss Tree': {
    apiFunction: orLossFilters,
    apiKPICard: orLossKPICardsData,
    tableComponent: OrLossTreeContainer
  }
};

// Helper function to get configuration
export const getORLTConfig = (alertType) => {
  return {
    kpiDetails: KPI_CONFIG[alertType] || [],
    uiConfig: UI_CONFIG[alertType] || {
      showFooter: false,
      showReviewCart: false,
      showActionPopup: false,
      showCustomizeColumns: false,
      showMoreFilters: false
    },
    apiConfig: API_CONFIG[alertType] || {}
  };
};